// Keep the deployment-provided URL as the source of truth, including preview.
export const resolveBackendUrl = (configuredUrl) => {
  if (!configuredUrl) {
    throw new Error('REACT_APP_BACKEND_URL is required');
  }

  const url = new URL(configuredUrl);
  if (!['http:', 'https:'].includes(url.protocol)) {
    throw new Error('REACT_APP_BACKEND_URL must be an HTTP(S) URL');
  }

  // Avoid sending API calls to the apex domain when production uses www.
  if (url.hostname === 'nakshatra.net.in') {
    url.hostname = `www.${url.hostname}`;
  }

  return url.toString().replace(/\/+$/, '');
};

export const BACKEND_URL = resolveBackendUrl(process.env.REACT_APP_BACKEND_URL);